import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import * as Assets from '@assets';
import { colorSet } from '@components/Provider';
import {
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
  makeStyles,
  DialogTitle,
  IconButton,
  Divider
} from '@material-ui/core';
import { ModalType } from './updateNoticeContents';
import CloseIcon from '@material-ui/icons/Close';
interface UpdateNoticeModalPresenterProps {
  modalType: ModalType;
  isOpen: boolean;
  content: JSX.Element;
  startTimeString: string;
  endTimeString: string;
  onClick: () => void;
  onClose: () => void;
}

const UpdateNoticeModalPresenter = ({
  modalType,
  isOpen,
  content,
  startTimeString,
  endTimeString,
  onClick,
  onClose
}: UpdateNoticeModalPresenterProps) => {
  const matches = useMediaQuery(useTheme().breakpoints.down('xs'));
  const classes = useStyles();

  return (
    <>
      {modalType === ModalType.Preview ? (
        <Dialog
          open={isOpen}
          onClose={onClose}
          className={classes.back}
          classes={{ paper: classes.previewpaper }}
          BackdropProps={{ invisible: true }}
        >
          <DialogTitle disableTypography className={classes.title}>
            <CustomizedTypography fontWeight="500">
              서비스 점검 예정 안내
            </CustomizedTypography>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClick}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Divider className={classes.divider} />
          <DialogContent className={classes.previewcontent}>
            <CustomizedTypography gutterBottoms={matches ? 20 : 25}>
              {content}
            </CustomizedTypography>
            <CustomizedTypography color="primary">
              서비스 점검 일시 :
            </CustomizedTypography>
            <CustomizedTypography color="primary">
              <b>
                {startTimeString} ~ {endTimeString}
              </b>
            </CustomizedTypography>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog
          open={isOpen}
          classes={{ paper: classes.paper }}
          className={classes.back}
        >
          <DialogContent classes={{ root: classes.content }}>
            <img
              className={classes.banner}
              src={Assets.SadMans3}
              alt="notice"
            />
            <CustomizedTypography
              variant={matches ? 'h5' : 'h2'}
              fontWeight="bold"
              gutterBottoms={16}
            >
              {modalType}
            </CustomizedTypography>

            <CustomizedTypography
              variant={matches ? 'body2' : 'body1'}
              fontWeight="500"
              color="textSecondary"
              gutterBottoms={matches ? 36 : 48}
            >
              {content}
            </CustomizedTypography>
            <CustomizedTypography
              variant="body1"
              fontWeight="bold"
              gutterBottoms={16}
            >
              서비스 점검 일시
            </CustomizedTypography>
            <div className={classes.footer}>
              <CustomizedTypography variant={'body1'} fontWeight="500">
                <b>
                  {startTimeString}
                  {matches && <br />} ~ {matches && <br />}
                  {endTimeString}
                </b>
              </CustomizedTypography>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default UpdateNoticeModalPresenter;

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '45px 32px 32px 32px',
    textAlign: 'center',
    zIndex: 3000,
    [theme.breakpoints.down('md')]: {
      padding: '30px 24px 26px 24px'
    }
  },
  banner: {
    margin: 'auto',
    marginBottom: 32,
    width: 315,
    [theme.breakpoints.down('md')]: {
      marginBottom: 24,
      width: 215
    }
  },
  content: {
    padding: 0,
    '& b': {
      color: colorSet.gray900,
      '&:last-child': {
        color: colorSet.primary500
      }
    }
  },
  footer: {
    marginTop: 24,
    backgroundColor: colorSet.gray200,
    borderRadius: 4,
    height: 80,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
    '& b': {
      color: colorSet.primary500
    },
    [theme.breakpoints.down('xs')]: {
      height: 100
    }
  },
  previewpaper: {
    borderRadius: '7px',
    position: 'absolute',
    right: 0,
    bottom: 0,
    boxShadow:
      '0px 1px 10px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
    [theme.breakpoints.down('md')]: {
      position: 'relative'
    }
  },
  back: {
    'z-index': '10000 !important'
  },
  title: {
    margin: 0,
    padding: '20px 17px',
    background: '#F5F5F5'
  },
  previewcontent: {
    padding: '22px 27px 32px 27px'
  },
  divider: {
    width: '100%',
    backgroundColor: colorSet.gray600
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: '8px'
  }
}));
